import {Component, Input} from '@angular/core';

@Component({
  selector: 'beaconstac-tag',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss']
})
export class TagsComponent {

  /**
   * Title for tag
   *
   * @required
   */
  @Input()
  tagTitle = 'Tag title';

  /**
   * Background color for tag
   *
   * @required
   */
  @Input()
  bgColor: string = '#DDEFFF';

  /**
   * Text color for tag
   *
   * @required
   */
  @Input()
  textColor: string = '#51AAFF';

  @Input()
  tooltipContent: string;

  @Input()
  tooltipEnabled: boolean;

}
